<template><div><h1 id="retourenauswertung-nach-retourquote" tabindex="-1"><a class="header-anchor" href="#retourenauswertung-nach-retourquote"><span>Retourenauswertung nach Retourquote</span></a></h1>
<p>Retourenauswertung nach Retourquote — Retourenauswertung nach Retourquote</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Liste zeigt pro Artikel den Anteil der Retouren an den Verkäufen (in Prozent des Umsatzwertes), ausserdem Anzahl und Wert der Retouren sowie der gesamten Verkäufe pro Artikel. Das Ergebnis kann nach verschiedenen Kriterien sortiert werden zur Beurteilung der Retourenquote.</p>
<p>Pfad: <code v-pre>Logistik → Auswertungen → Retourenauswertung nach Retourquote</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Datum von</dt>
<dd>Bewegungsdatum von</dd>
<dt>bis</dt>
<dd>Bewegungsdatum bis</dd>
<dt>Art.gruppen</dt>
<dd>Artikelgruppe, mit Komma trennen, * = alle (Standard)</dd>
<dt>Auftragsart</dt>
<dd>Auftragsart, mit Komma trennen, * = alle (Standard)</dd>
<dt>Medium</dt>
<dd>Medium, mit Komma trennen, * = alle (Standard)</dd>
<dt>Sortierung</dt>
<dd>(P)rozent Retourenwert, (R)etourenwert, (A)nzahl Retouren</dd>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Portrait)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Bt</td>
<td>Bewegungstyp</td>
</tr>
<tr>
<td>Gr</td>
<td>Artikelgruppe</td>
</tr>
<tr>
<td>Artikel</td>
<td>Artikelnummer</td>
</tr>
<tr>
<td>Artikelbezeichnung</td>
<td>Artikelbezeichnung</td>
</tr>
<tr>
<td>Anz.V</td>
<td>Anzahl Verkäufe = [Anz. Bewegungstyp W] - [Anz. Bewegungstyp WS]</td>
</tr>
<tr>
<td>Anz.R</td>
<td>Anzahl Retouren = [Anz. Bewegungstyp WS]</td>
</tr>
<tr>
<td>Wert.V</td>
<td>Wert Verkäufe = [Anz. V] * [Verkaufspreis Artikelbewegungen]</td>
</tr>
<tr>
<td>Wert.R</td>
<td>Wert Retouren = [Anz. R] * [Verkaufspreis Artikelbewegungen]</td>
</tr>
<tr>
<td>% Wert</td>
<td>Prozentwert Retouren = [Anz. R] * 100 / [Anz. V]</td>
</tr>
</tbody>
</table>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line">Datenausgabe                          15.09.2000 09:38:27 leh  Seite     0</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">                              Retourenauswertung</span>
<span class="line">Beschreibung: Die Liste zeigt pro Artikel den Anteil der Retouren an den Ver-</span>
<span class="line">käufen (in Prozent des Umsatzwertes), ausserdem Anzahl und Wert der Retouren</span>
<span class="line">sowie der gesamten Verkäufe. Das Ergebnis wird so sortiert, dass die höchste</span>
<span class="line">Retourenquote zuoberst erscheint.</span>
<span class="line"></span>
<span class="line">Parameter: Datum von....: 01.08.2000 bis: 31.08.2000</span>
<span class="line">           Art.gruppen..: \*</span>
<span class="line">           Auftragsart..: \*</span>
<span class="line">           Medium.......: \*</span>
<span class="line">           Export Format: T</span>
<span class="line"></span>
<span class="line">           Sortierung...: P Prozent Retourenwert</span>
<span class="line"></span>
<span class="line"></span>
<span class="line"></span>
<span class="line">Artikel Gr    Artikelbezeich.  Anz.V Anz.R     Wert.V     Wert.R %.Wert</span>
<span class="line">------- ----- ---------------- ----- ----- ---------- ---------- ------</span>
<span class="line">3518.00 135   Langarmshirt, sc    10     1     350.00      35.00  10.00%</span>
<span class="line">3214.00 107   Langarmshirt, we    12     1     588.00      49.00   8.50%</span>
<span class="line">3304.00 105   Langarmshirt, bl    28     2   1,624.00      58.00   7.14%</span>
<span class="line">.</span>
<span class="line">.</span>
<span class="line">.</span>
<span class="line">0719.01 95120 Alunit, Deodoran   161     2   1,941.70      38.00   1.96%</span>
<span class="line">                               ----- ----- ---------- ----------</span>
<span class="line">                                 696   197  26,926.70  11,328.30         TOTAL</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Lesebeispiel: Der Artikel 3214.00 Langarmshirt, we verzeichnete die zweithöchste Retourenquote: von einem Gesamtumsatz von Fr. 588.-- wurden Retouren in Höhe von Fr. 49.-- verzeichnet. Dies entspricht einer Retourenquote von 8.5%.</p>
</div></template>


